module.exports = __webpack_public_path__ + "static/media/oishi.454b875c.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/oishi.mp3
 ** module id = 673
 ** module chunks = 0
 **/